import { Injectable } from "@angular/core"
import { CookieService } from "ngx-cookie-service"
import { buildCookieServiceOptions } from "./cookie.utils"

@Injectable({ providedIn: 'root' })
export class ActivesoftIntegrationUtil {
  constructor(private cookieService: CookieService) { }

  getActivesoft(): string {
    return this.cookieService.get('activesoft')
  }

  setActivesoft(activesoft: string) {
    this.cookieService.set('activesoft', activesoft, buildCookieServiceOptions(false))
  }

  idActivesoftWithoutPrefix(idActivesoft: string): string {
    const prefix = idActivesoft.trim().substring(0, 1)
    if (prefix === 'A' || prefix === 'R') {
      return idActivesoft.trim().substring(1, idActivesoft.trim().length)
    } else {
      return idActivesoft.trim()
    }
  }
}